import { LoadingSpinner as LoadingSpinnerPrime } from "components/LoadingSpinner";
import { ProgressSpinner } from "primereact/progressspinner";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";

const RecommendationsContainer = styled.div`
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  padding: 1rem;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const QuantityLink = styled.button<{ $isLoading?: boolean }>`
  background: none;
  border: none;
  color: var(--primary-500);
  text-decoration: underline;
  cursor: ${({ $isLoading }) => ($isLoading ? "not-allowed" : "pointer")};
  font-size: inherit;
  font-family: inherit;
  padding: 0;
  margin: 0;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.6 : 1)};
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;

  &:hover {
    color: ${({ $isLoading }) =>
      $isLoading ? "var(--primary-500)" : "var(--primary-600)"};
    text-decoration: ${({ $isLoading }) => ($isLoading ? "underline" : "none")};
  }

  &:focus {
    outline: 2px solid #007ad6;
    outline-offset: 1px;
    border-radius: 2px;
  }
`;

const LoadingSpinner = styled.span`
  display: inline-flex;
  margin-left: 0.25rem;
`;

interface ICptCodeQuantityRecommendationsProps {
  onRecommendationClick: (cptCode: string, suggestedQuantity: number) => void;
  loadingCptCode?: string | null;
}

export function CptCodeQuantityRecommendations({
  onRecommendationClick,
  loadingCptCode,
}: ICptCodeQuantityRecommendationsProps) {
  const { cptQuantityRecommendations, loadingCptQuantityRecommendations } =
    useSelector((state: RootState) => state.serviceDetailsSlice);

  if (loadingCptQuantityRecommendations) {
    return (
      <LoadingSpinnerPrime customStyle={{ width: "16px", height: "16px" }} />
    );
  }

  if (!cptQuantityRecommendations || cptQuantityRecommendations.length === 0) {
    return null;
  }

  return (
    <RecommendationsContainer>
      {cptQuantityRecommendations.map((recommendation) => {
        const isLoading = loadingCptCode === recommendation.cptCode;

        return (
          <div className="text-sm font-normal" key={recommendation.cptCode}>
            <span className="font-semibold">{recommendation.cptCode}</span>{" "}
            <span className="text-gray-700">Common Quantity: </span>
            <QuantityLink
              $isLoading={isLoading}
              onClick={() =>
                onRecommendationClick(
                  recommendation.cptCode,
                  recommendation.suggestedQuantity
                )
              }
              disabled={isLoading}
            >
              {recommendation.suggestedQuantity}
              {isLoading && (
                <LoadingSpinner>
                  <ProgressSpinner
                    style={{ width: "12px", height: "12px" }}
                    strokeWidth="4"
                  />
                </LoadingSpinner>
              )}
            </QuantityLink>{" "}
            <span className="text-gray-500">
              ({recommendation.occurrenceRate}%)
            </span>
          </div>
        );
      })}
    </RecommendationsContainer>
  );
}
